<div class="mrs-table-container">
  <div class="mrs-table-inner-container">
    <div class="flex flex-align-center">
      <mat-form-field
        id="filterCasesFormField"
        class="filter-cases"
        floatLabel="never"
        appearance="fill"
        *ngIf="searchableFields && searchableFields.length > 0"
      >
        <input
          matInput
          placeholder="Search"
          name="filterValue"
          (keyup)="updateFilteredCases()"
          [(ngModel)]="filterValue"
        >
        <mat-icon class="case-summary-search-icon" aria-hidden="false" aria-label="Case search icon" matSuffix>
          search
        </mat-icon>
      </mat-form-field>

      <div class="ms-2" style="width: 22rem" *ngIf="showClientFilter">
        <app-multi-select-dropdown-list
          class="multi-select-dropdown-list"
          [listTitle]="'Filter by Client'"
          [completeList]="clients"
          (selectionChanged)="filterData($event)"
        >
        </app-multi-select-dropdown-list>
      </div>

      <!-- <form class="ms-2" [formGroup]="showInactiveTeamsFormGroup" ngNativeValidate>
        <mat-slide-toggle formControlName="hasInactiveTeamsCtrl">Show inactive teams</mat-slide-toggle>
      </form> -->

      <button
        mat-button
        color="primary"
        class="material-default flex-end"
        (click)="createTeam()"
        style="margin-top: 15px; margin-left: auto"
        *ngIf="addRecordAction && addRecordAction.permission"
      >
        <mat-icon>add</mat-icon>
        <span style="margin-top: 2px">{{ addRecordAction.name }}</span>
      </button>
    </div>

    <div style="max-height: 60vh; overflow-y: scroll;">
      <table
        mat-table
        aria-label="Elements"
        [dataSource]="mrsDataSource"
        matSort
        [matSortActive]="initialSort"
        matSortDirection="asc"
        style="width:100%; overflow:hidden;"
      >
        <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column.def">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            [disabled]="userProfileV2 && column.def === 'actions'"
            [ngStyle]="column.columnStyles"
          >
            {{ column.header }}
          </th>

          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="!column.isAction; else actionCell">
              <div *ngFor="let rowDef of column.rowDefs">
                <div [ngClass]="rowDef.className">{{ row[rowDef.dataName] }}</div>
              </div>
            </ng-container>
            <ng-template #actionCell>
              <ng-container *ngIf="showActionsColumn">
                <div class="w-100 text-end">
                  <button
                    *ngFor="let action of column.actions"
                    type="button"
                    mat-button
                    color="primary"
                    class="material-default"
                    (click)="tableAction(action, row)"
                  >
                    VIEW
                  </button>
                </div>
              </ng-container>
            </ng-template>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsDef; sticky: true"></tr>
        <tr mat-row (click)="onRowClicked(row)" *matRowDef="let row; columns: displayedColumnsDef;" class="row-height" style="cursor: pointer"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            <div class="p-4 text-center text-muted">
              <img src="./assets/images/no-data-placeholder.png" alt="" class="pb-3" />
              <h6>No Teams Found</h6>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>

  <div>
    <div class="flex mat-paginator-sticky mat-mdc-paginator-container">
      <mat-paginator
        #paginator
        [length]="mrsDataSource?.data?.length || 0"
        [pageIndex]="0"
        [pageSize]="10"
        (page)="setStyles()"
        appearance="fill"
        [pageSizeOptions]="[10, 25, 50, 100]"
      >
      </mat-paginator>
    </div>
  </div>
</div>
